import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  UserLogin,
  UserType,
  User,
  ResponseAPI,
} from "../../models/user.model";
import { environment } from "src/environments/environment";
import { Observable, Subject, BehaviorSubject, lastValueFrom } from "rxjs";
import { Storage } from "@ionic/storage-angular";
import { Platform } from "@ionic/angular";
import { Capacitor } from "@capacitor/core";
import OneSignal from "onesignal-cordova-plugin";
import { CrudService } from "./crud.service";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  redirectUrl: string;
  public user: User;
  public $controlAuth = new Subject<User>();
  public $isLogged = new BehaviorSubject<boolean>(null);
  constructor(
    private http: HttpClient,
    private storage: Storage,
    private platform: Platform,
    private crudService: CrudService
  ) {}

  async dataAuth() {
    this.user = JSON.parse(await this.storage.get("user"));
    this.$controlAuth.next(this.user);
    return this.user;
  }

  async getClaim() {
    const dataAuth = await this.dataAuth();
    return dataAuth ? dataAuth.userType : null;
  }

  async getToken() {
    const dataAuth = await this.dataAuth();
    if (dataAuth) return dataAuth.token;
    return "";
  }

  public async saveAuth(user) {
    this.user = user;
    this.$controlAuth.next(this.user);
    await this.storage.set("user", JSON.stringify(user));
  }

  public async logoutUser() {
    try {
      this.user = null;
      this.$controlAuth.next(this.user);
      this.$isLogged.next(false);
      localStorage.clear();
      sessionStorage.clear();
      await this.storage.remove("user");
      await this.storage.clear();
      this.clearCookies();
      if (Capacitor.isNativePlatform()) {
        OneSignal.logout();
      }
      this.setRedirectUrl("");
    } catch (error) {}
  }

  private clearCookies() {
    const cookies = document.cookie.split("; ");
    for (let c = 0; c < cookies.length; c++) {
      let d = window.location.hostname.split(".");
      while (d.length > 0) {
        let cookieBase =
          encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
          "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
          d.join(".") +
          " ;path=";
        let p = location.pathname.split("/");
        document.cookie = cookieBase + "/";
        while (p.length > 0) {
          document.cookie = cookieBase + p.join("/");
          p.pop();
        }
        d.shift();
      }
    }
  }

  public loginUser(credentials: UserLogin): Observable<any> {
    return this.http.post(
      `${environment.API_BASE}api/account/login`,
      credentials
    );
  }

  async isLogged() {
    const hasToken = (await this.getToken()) !== "";
    if (!hasToken) {
      this.$isLogged.next(false);
    } else {
      this.$isLogged.next(true);
    }
    return hasToken;
  }

  public registerUser(values: object, typeUser: UserType): Observable<any> {
    if (typeUser === UserType.Caller) {
      return this.http.post(`${environment.API_BASE}api/vendedor`, values);
    }

    return this.http.post(`${environment.API_BASE}api/motorista`, values);
  }

  async setRedirectRole() {
    let route = [];
    switch (await this.getClaim()) {
      case UserType.Caller:
        route = this.redirectUrl ? [this.redirectUrl] : ["call", "dashboard"];
        break;
      case UserType.Driver:
        const response = await lastValueFrom<any>(
          this.crudService.getData("motorista/is-online")
        );
        console.log(response);
        if (response.success && response.data) {
          route = this.redirectUrl
            ? [this.redirectUrl]
            : ["driver", "information-queue"];
        } else {
          route = this.redirectUrl ? [this.redirectUrl] : ["driver", "queue"];
        }
        console.log(route);
        break;
      case UserType.Restaurant:
        route = this.redirectUrl
          ? [this.redirectUrl]
          : ["call", "reservations-requests"];
        break;
      default:
        break;
    }
    return route;
  }
  public setRedirectUrl(url: string) {
    this.redirectUrl = url;
  }
}
